<template>
    <v-card variant="flat" style="height: 100%; width: 100%;overflow-y: auto; overflow-x: auto;" class="px-4 py-4">
      <v-row class="pa-2 customer" :style="{ marginBottom: role < 6 ? '10px' : '0px' }">
        <v-col cols="9" class="py-0 d-flex align-center ga-5">
          <h2 class="clientname">Customers</h2>
          <TemplateDownload v-if="role < 6" :data="excelTemplate" text="customers"/>
        </v-col>
        <v-col cols="3" class="py-0  d-flex align-center justify-end">
            <!-- <ExcelUpload @uploaded="addCustomer" showCard="product"/> -->
            <v-btn v-if="role < 6" class="ml-3" color="primary" variant="outlined" @click="startSync">
                  <v-icon left :class="{ 'rotating': isSyncing }">mdi-sync</v-icon>
                  {{ isSyncing ? 'Syncing' : 'Sync' }}
            </v-btn> 
            <ExcelUpload v-if="role < 6" @uploaded="addCustomer" showCard="customer"/>
        </v-col>
      </v-row>  
      <div class="pa-2 table-container" style="height: 100%; width: 100%; overflow-x: auto;">
          <Table v-if="headers.length > 0" @dialogs="edit" :title="'Customers'" :role="role" :headers="headers" :dataList="customerDetails" />
      </div>
    </v-card>
    <v-dialog v-model="customerDialog" width="800">
      <CustomersForm @update-location="updateLocation" :index="index" :viewType="viewType" :designation="'Customers'" :customerForm="customerForm"  @close="close"/>
    </v-dialog>
  </template> 
  
  <script>
import ExcelUpload from '@/menus/ExcelUpload.vue';
import clientDetailsService from '@/api/service/ClientDetails/ClientDetailsService';
import TemplateDownload from '@/menus/TemplateDownload.vue';
// import Export from '@/menus/Export.vue';
import Table from '@/menus/Table.vue'
import CustomersForm from './CustomersForm.vue';
import moment from "moment";
import DatamodelDetailsService from '@/api/service/DataModelDetails/DataModelsDetailsService';
// import { customers } from '@/api/model/CustomerModel';


  export default {
    components: {
      ExcelUpload,
      TemplateDownload,
      // Export,
      CustomersForm,
      Table,
    },
    data() {
      return {
        headers:[
          // {title:"Customer",value:'customer',minWidth:'200px'},
          // // {title:"Name",value:'name',minWidth:'300px'},
          // // {title:"Alert",value:'alert',minWidth:'150px'},
          // {title:"Factor",value:'factor',minWidth:'150px'},
          // {title:"EDI",value:'edi',minWidth:'150px'},
          // {title:"UCC Lables",value:'ucc_labels',minWidth:'200px'},
          // {title:"ASN",value:'asn',minWidth:'200px'},
          // {title:"Substitution",value:'substitution',minWidth:'200px'},
          // {title:"OffPack",value:'off_pack',minWidth:'200px'},
          // {title:"CustomerType",value:'customer_type',minWidth:'200px'},
          // {title:"DirectCustomer",value:'direct_customer',minWidth:'200px'},
          // {title:"855",value:'c855',minWidth:'200px'},
          // {title:"940&997",value:'c940997',minWidth:'200px'},
          // {title:"CoursesofAction",value:'courses_of_action',minWidth:'700px'},
          // {title:"Modified By",value:'modified_name',minWidth:'250px'},
          // {title:"Modified Date",value:'modified',minWidth:'250px'},
        ],
        isSyncing: false,
        viewType:null,
        index:null,
        customerDialog:false,
        customerForm:[],
        customer:[],
        customerDetails:[],
        user_id:null,
        user_name:null,
        role:null,
        excelTemplate: [],
        getModelColumn:[],
      }
    },
    created() {
        this.getModeldata()
        this.getOrganisation();
        let user = localStorage.getItem('user_details')
        user = JSON.parse(user)
        this.user_id = user.id
        this.user_name = user.username
        this.role = user.roles.role_type
        this.getExcelHeaders()
        console.log(this.user_id,"this.user_id!!")
    },
    methods: {
        async getModeldata(){
            try {
              let res = await DatamodelDetailsService.findAll({model_id:21,column_required:1})
              console.log(res,"res!!###")
              this.headers = res || []
              this.headers.forEach((item)=>{
                item.column_name == 'courses_of_ction'?item.minWidth='500px':item.minWidth='200px'
                item.title = item.label
                item.value = item.column_name
                this.excelTemplate.push(item.column_name)
              })
              this.headers.push({ title: "Actions", value: 'actions', minWidth: '150px',})
              console.log(this.headers,"this.headers")
            } catch (error) {
              console.log(error)
            }
        },
        startSync() {
          this.isSyncing = true;
          setTimeout(() => {
            this.isSyncing = false;
          }, 4000);
        },
        getExcelHeaders() {
          this.excelTemplate = this.headers.map((header) => header.value)
        },
        async getOrganisation() {
            let $id = this.$route.query.id
            this.organisationData = await clientDetailsService.findOne({ id: $id, collectionName: 'organisation' })
            this.customerDetails = this.organisationData && this.organisationData.customers ? this.organisationData.customers : this.customerDetails
        },

        close() {
            this.customerDialog = false
        },
        async save() {
            console.log("tttt!!!")
            this.organisationData.customers = this.customerDetails
            let $data = {
                collectionName: 'organisation',
                data: this.organisationData,
                id:this.$route.query.id
            }
            await clientDetailsService.update($data)
        },
        addCustomer($data){
            this.customerDetails = $data
            let count = 0
            if(this.organisationData && this.organisationData.customers && Array.isArray(this.organisationData.customers)){
              count = this.organisationData.customers.length
            }
            for(let i of this.customerDetails){
              const now = moment().format('YYYY-MM-DD HH:mm:ss')
                i.id = ++count
                i.created = now
                i.modified = null
                i.created_by = this.user_id  
                i.modified_by = null
                i.modified_name = null
                i.active = 1
                i.deleted = 0
                i.deleted_by = null
              console.log(i ,"loop")
            }
            this.save()
        console.log(this.customerDetails,'geufeu')
        },

        async edit($edit,bool,viewType,index){
          this.customerDialog=true
          this.customerForm = $edit
          this.viewType = viewType
          this.index = index
          console.log("$edit !!",$edit,bool,viewType,index)

        },

        updateLocation(data,index,type){
          console.log(data,"updatelocation !!")
            if(type == 'edit'){
                const now = moment().format('YYYY-MM-DD HH:mm:ss')
                data.modified = now
                data.modified_by = this.user_id
                data.modified_name = this.user_name
                this.customerDetails[index] = data
                this.saveAllData()
            }

        },
        async saveAllData() {
            this.organisationData.customers = this.customerDetails
            let $data = {
                collectionName: 'organisation',
                data: this.organisationData,
                id: this.$route.query.id
            }
            await clientDetailsService.update($data)
            // window.location.reload()
        },
    },
  };
  </script>
  
  <style scoped>
  .customer{
    display: flex;
    align-items: center;
  }
  .upload-btn {
  /* background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%); */
  color: white;
  font-weight: 600;
  text-transform: none; /* keep 'Upload' normal instead of uppercase */
  border-radius: 12px;
  padding: 10px 20px;
  transition: all 0.3s ease;
}
  .clientname {
    font-size: 20px;
    font-weight: 600;
  }
  
  .table-container {
    width: 100%;
     /* background: #ebf1f35a; */
    background: #fff;
    padding: 8px 15px;
    border-radius: 4px;
    /* // border: 1px solid #d2d2d2; */

    table {
        width: 100%;
        border-collapse: separate;
        border-spacing: 0 10px;

        thead {
        border: 1px solid #cbf0fd;
        background-color: #e3f2fd;

        th {
            font-size: 1rem;
            font-weight: 500;
            padding: 12px;
            text-align: left;
            color: #000;
        }
        }

        tbody {
        tr {
            cursor: pointer;
            font-size: 0.9rem;
            font-weight: 500;
            position: relative;
            overflow: hidden;
            border: 1px solid #cbf0fd;
            border-radius: 8px;

            &:nth-child(odd) {
            background-color: #ebf1f3;
            }

            &:nth-child(even) {
            background-color: #d9dbdb;
            }

            td {
            padding: 10px;
            text-align: left;
            color: #333;
            }

            &:hover {
            background-color: #f5f5f5;
            }
        }
        }
    }
    }
    .edit-btn {
    background: transparent;
    border: none;
    cursor: pointer;
    font-size: 16px;
    }

    .noWrap{
    text-wrap:nowrap;
    }
    .no-data-container{
    display:flex;
    justify-content:center;
    align-items:center;
    width: 100%;
    height:400px;
    font-size:20px; 
    font-weight:500;
    }
    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(-360deg);
      }
    }
    .rotating {
      animation: spin 1s linear infinite;
    }
  </style>